import { FCX } from "@datassential/platform-ui-lib";
import cn from "classnames";
import { ReactNode, useCallback, useMemo } from "react";
import { getPercentageValue } from "@core/utils/chart";

type Modifiers = 'inline'

const HorizontalBar: FCX<{
	value: number;
	label?: ReactNode;
	maxValue?: number;
	color?: string;
	modifiers?: Modifiers[];
}> = ({
	value,
	maxValue = 100,
	color = "#EB0087",
	label = null,
	className,
	modifiers = [],
	testId
}) => {
	const getBarWidthPct = useCallback(
		(value: number) => getPercentageValue(value, maxValue),
		[maxValue]
	);

	const isInline = modifiers.includes('inline')

	const bar = useMemo(() => (
		<div
			className="HorizontalBar__bar"
			style={{
				flex: `0 0 ${getBarWidthPct(value)}%`,
				backgroundColor: color,
			}}
			data-testid={"blockHorizontalBar"}
		/>
	), [value, getBarWidthPct, color])

	return (
		<div
			className={cn(
				"HorizontalBar",
				className,
				...modifiers.map(modifier => `is-${modifier}`)
			)}
			data-testid={testId}
		>
			<div className="HorizontalBar__wrapper">
				{
					isInline ? (
						<div className="HorizontalBar__bar-bg">
							{bar}
						</div>
					) : bar
				}
				<div
					className="HorizontalBar__value"
					data-testid={"textHorizontalBarValue"}
				>
					{label}
				</div>
			</div>
		</div>
	)
}

export default HorizontalBar;